import { gql, useQuery } from "@apollo/client";

export const GET_JOBS_LIST = gql`
  query getJobs(
    $activityId: ID
    $limit: Int!
    $cursor: String
    $createdBy: String
  ) {
    getJobs(
      input: {
        activityId: $activityId
        limit: $limit
        cursor: $cursor
        createdBy: $createdBy
      }
    ) {
      jobs {
        id
        name
        status
        createdAt
        createdBy
        activityId
        commands
        environmentVariables {
          name
          value
        }
        image {
          id
          name
          environmentType
          environmentTypeVersion
        }
      }
      totalCount
      nextCursor
    }
  }
`;

export function useGetJobsList(
  activityId?: number,
  limit: number = 20,
  cursor?: string | null,
  createdBy?: string
) {
  const {
    data: jobList,
    loading: isGetJobsListLoading,
    error: errorGetJobsList,
    refetch: refetchJobList,
    fetchMore: fetchMoreJobs
  } = useQuery(GET_JOBS_LIST, {
    variables: {
      ...(activityId && { activityId }),
      ...(limit && { limit }),
      ...(cursor && { cursor }),
      ...(createdBy && { createdBy })
    },
    context: { clientName: "execution" },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only"
  });
  return {
    jobList,
    isGetJobsListLoading,
    errorGetJobsList,
    refetchJobList,
    fetchMoreJobs
  };
}
